// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5222":"f0879cc6","5782":"c6021dea"}[chunkId] + ".chunk.css";
};